import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ViajeCobranzaDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Folio", cell: x => ({ data: x.Folio }) },
    { title: "Fecha de creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Cant. facturas", cell: x => ({ data: x.CantFacturas }) },
    { title: "Cant. facturas pagadas", cell: x => ({ data: x.CantFacturasPagadas }) },
    { title: "Saldo facturas", cell: x => ({ data: x.SaldoFacturas, view: kea.formatCurrency }) },
    { title: "Total facturas", cell: x => ({ data: x.TotalFacturas, view: kea.formatCurrency }) },
];

export interface BotonesDeps {
    onVer: (x: Entity) => void;
    onImprimir: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): Column[] {
    const botones = kea.columnaBotones<Entity>([
        {
            iconClass: fa("eye"),
            onClick: deps.onVer,
            tooltip: "Ver"
        }, {
            iconClass: fa("print"),
            onClick: deps.onImprimir,
            tooltip: "Imprimir"
        }
    ]);
    return [botones, ...columnasFijas];
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/list/columns.tsx